import { TaskStatus } from "../module/private/task/entity/task.model";
import { Group } from "../module/private/user/entity/user.model";
import { Auth } from "../module/public/auth/entity/auth.model";
import { api } from "./api";
import { mConstants } from "./constants";
import storeService from "./store";

function isLogged(): boolean {
  return storeService.getToken() !== null;
}

function getUser(): Auth | undefined {
  if (isLogged()) {
    return storeService.getUser();
  }

  return undefined;
}

function getRoles(): string[] {
  let user = getUser();

  if (
    user?.resource_access &&
    "maximus-admin-web" in user?.resource_access &&
    "roles" in user?.resource_access["maximus-admin-web"]
  ) {
    return user?.resource_access["maximus-admin-web"]["roles"];
  }

  return [];
}

function hasRoles(roles: string[]): boolean {
  let _roles = getRoles();

  for (const _role of _roles) {
    if (roles.includes(_role)) {
      return true;
    }
  }

  return false;
}

async function getImage(imageName: string): Promise<File | undefined> {
  if (!imageName || imageName === null) return undefined;

  try {
    const response: Blob = await api.get(
      mConstants.API_URL + mConstants.FILE_DOWNLOAD_PATH + imageName,
      {
        responseType: "blob",
      }
    );
    return new File([response], imageName);
  } catch (e) {
    return undefined;
  }
}

async function getPublicImage(imageName: string): Promise<File | undefined> {
  if (!imageName || imageName === null) return undefined;

  try {
    const response: Blob = await api.get(
      mConstants.API_URL + mConstants.PUBLIC_FILE_DOWNLOAD_PATH + imageName,
      {
        responseType: "blob",
      }
    );
    return new File([response], imageName);
  } catch (e) {
    return undefined;
  }
}

async function getImageUrl(imageName: string): Promise<string | undefined> {
  if (!imageName || imageName === null) return undefined;

  try {
    const response: Blob = await api.get(
      mConstants.API_URL + mConstants.FILE_DOWNLOAD_PATH + imageName,
      {
        responseType: "blob",
      }
    );
    return URL.createObjectURL(response);
  } catch (e) {
    return undefined;
  }
}

function getUserFullName(user?: Auth) {
  return `${user?.given_name} ${user?.family_name}`;
}

function getTaskStatus(status?: TaskStatus) {
  switch (status) {
    case TaskStatus.NEW:
      return "Шинэ";
    case TaskStatus.CANCELED:
      return "Цуцласан";
    case TaskStatus.PENDING:
      return "Хүлээгдэж буй";
    case TaskStatus.DECLINED:
      return "Зөвшөөрөөгүй";
    case TaskStatus.APPROVED:
      return "Зөвшөөрөгдсөн";
    default:
      return "Тодорхойгүй";
  }
}

function getTaskType(taskType?: string) {
  if (taskType === "SALES") {
    return "Борлуулалт";
  } else if (taskType === "STALL") {
    return "Өрөлт";
  } else {
    return "Тодорхойгүй";
  }
}

function getCustomerRequestType(taskType?: string) {
  if (taskType === "ADD") {
    return "Шинээр нэмэгдсэн";
  } else if (taskType === "UPDATE") {
    return "Өөрчлөлт оруулсан";
  } else {
    return "Тодорхойгүй";
  }
}

function isRouteRule(group?: Group) {
  if (
    group?.attributes?.routeRule?.length > 0 &&
    group?.attributes?.routeRule[0] == "multiple"
  ) {
    return true;
  } else {
    return false;
  }
}

const helper = {
  getRoles,
  isLogged,
  getUser,
  getImage,
  getImageUrl,
  getUserFullName,
  getTaskStatus,
  hasRoles,
  getTaskType,
  getCustomerRequestType,
  isRouteRule,
  getPublicImage,
};

export default helper;
